import {QuillModules} from 'ngx-quill/config';

/**
 * Toolbar of the policy content editor: fonts, sizes, inline styles, links, lists, alignment and indent.
 * No text / background color: Quill stores colors as inline `style`, which the editor's `sanitize`
 * option (Angular's sanitizer) strips, so a color would be lost the next time the policy is opened.
 */
export const TERMS_EDITOR_MODULES: QuillModules = {
  toolbar: [
    [{font: []}, {size: ['small', false, 'large', 'huge']}],
    ['bold', 'italic', 'underline', 'strike'],
    ['link'],
    [{list: 'bullet'}, {list: 'ordered'}],
    [{align: []}],
    [{indent: '-1'}, {indent: '+1'}],
    ['clean']
  ]
};

/**
 * The only formats the editor keeps - matches the toolbar. Anything else is dropped, including
 * images pasted or dragged in: Quill embeds them as base64 in the HTML, which every agent's app
 * would then have to download.
 */
export const TERMS_EDITOR_FORMATS: string[] = [
  'font', 'size',
  'bold', 'italic', 'underline', 'strike',
  'link',
  'list',
  'align',
  'indent'
];
